<template>
  <path
    d="M7 12.0002C7 12.5502 7.45 13.0002 8 13.0002H16C16.55 13.0002 17 12.5502 17 12.0002C17 11.4502 16.55 11.0002 16 11.0002H8C7.45 11.0002 7 11.4502 7 12.0002ZM12 2.00018C6.48 2.00018 2 6.48018 2 12.0002C2 17.5202 6.48 22.0002 12 22.0002C17.52 22.0002 22 17.5202 22 12.0002C22 6.48018 17.52 2.00018 12 2.00018ZM12 20.0002C7.59 20.0002 4 16.4102 4 12.0002C4 7.59018 7.59 4.00018 12 4.00018C16.41 4.00018 20 7.59018 20 12.0002C20 16.4102 16.41 20.0002 12 20.0002Z"
  />
</template>
